module.exports = __webpack_public_path__ + "img/icon.19bc186e.png";